/* Swisskom – taburi de conținut + timer coș */
(function () {
  if (!customElements.get('swk-tabs')) {
    customElements.define(
      'swk-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (e) => {
            const btn = e.target.closest('.content-tab-button');
            if (!btn || !this.contains(btn)) return;
            this.select(btn.dataset.tab);
          });
        }
        select(id) {
          this.querySelectorAll('.content-tab-button').forEach((b) => {
            const on = b.dataset.tab === id;
            b.classList.toggle('content-tab-button--active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          this.querySelectorAll('.content-tab-panel').forEach((p) => {
            p.hidden = p.id !== 'TabPanel-' + id;
          });
        }
      }
    );
  }

  // Timer „coș rezervat”: pornește la prima afișare și se păstrează pe durata sesiunii.
  const KEY = 'swkCartTimerEnd';
  function getEnd(duration) {
    let end = 0;
    try {
      end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    } catch (e) {}
    const now = Date.now();
    if (!end || end < now) {
      end = now + duration * 1000;
      try {
        sessionStorage.setItem(KEY, String(end));
      } catch (e) {}
    }
    return end;
  }
  function tick() {
    document.querySelectorAll('[data-swk-timer]').forEach((el) => {
      const duration = parseInt(el.dataset.swkTimer, 10) || 300;
      const end = getEnd(duration);
      const left = Math.max(0, Math.round((end - Date.now()) / 1000));
      const m = String(Math.floor(left / 60)).padStart(2, '0');
      const s = String(left % 60).padStart(2, '0');
      const t = el.querySelector('.swk-cart-timer__time');
      if (t) t.textContent = m + ':' + s;
    });
  }
  tick();
  setInterval(tick, 1000);

  // Butonul „Adaugă” de pe cardurile de produs: adaugă în coș și deschide coșul lateral.
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('.swk-card__addform');
    if (!form) return;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.getSectionsToRender !== 'function') return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    const formData = new FormData(form);
    formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
    formData.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) return;
        cart.classList.remove('is-empty');
        if (typeof cart.renderContents === 'function') cart.renderContents(res);
      })
      .catch(() => {})
      .finally(() => {
        if (btn) btn.classList.remove('is-loading');
      });
  });
})();
